/**
 * Soundboard translations — EN → FR
 * Used when site language is 'fr' to display French sound/category names.
 * Falls back to the original English name if no translation exists.
 */

// ── Category translations ──
export const categoryTranslations = {
  'Age of Sail':        'Âge de la Voile',
  'Ancient Greece':     'Grèce Antique',
  'Atlantis':           'Atlantide',
  'Bleakwater Docks':   'Quais de Sombréau',
  'Castle Raven':       'Château du Corbeau',
  'Combat':             'Combat',
  'Combat Future':      'Combat Futuriste',
  'Combat_Siege_':      'Siège',
  'Cthulhu':            'Cthulhu',
  'Dark Forest':        'Forêt Sombre',
  'Desert Planet':      'Planète Désertique',
  'Dungeon':            'Donjon',
  'Film_Noir_':         'Film Noir',
  'Future City':        'Ville Futuriste',
  'House on the Hill':  'Maison sur la Colline',
  'Ice Planet':         'Planète de Glace',
  'Jungle Planet':      'Planète Jungle',
  'Olde Towne':         'Vieux Bourg',
  'Sanctum':            'Sanctuaire',
  'Starship':           'Vaisseau Spatial',
  'Tavern':             'Taverne',
  'True West':          'Far West',
  'Vampire':            'Vampire',
  'Vikings':            'Vikings',
  'Wasteland':          'Terres Désolées',
  'Weirder Things':     'Choses Étranges',
};

// ── Sound name translations ──
export const soundTranslations = {
  // === A ===
  'Agora':                    'Agora',
  'Air Filled Chamber':       'Chambre Remplie d\'Air',
  'Air Strike1':              'Frappe Aérienne 1',
  'Air Strike2':              'Frappe Aérienne 2',
  'Alarm':                    'Alarme',
  'Alarm1':                   'Alarme 1',
  'Alarm2':                   'Alarme 2',
  'Analog Static':            'Parasites Analogiques',
  'Angry Crowd':              'Foule en Colère',
  'Announcements1':           'Annonces 1',
  'Announcements2':           'Annonces 2',
  'Announcements3':           'Annonces 3',
  'Announcements4':           'Annonces 4',
  'Antiquarian Shop':         'Boutique d\'Antiquaire',
  'Arcade':                   'Arcade',
  'Arcane Spell':             'Sort Arcanique',
  'Archer Volley':            'Volée d\'Archers',
  'Archers Draw':             'Archers Bande',
  'Archers Loose':            'Archers Lâchent',
  'Arrow Shot1':              'Tir de Flèche 1',
  'Arrow Shot2':              'Tir de Flèche 2',
  'Arrow Trap':               'Piège à Flèches',
  'Assualt Weapons Bg':       'Armes d\'Assaut (Fond)',
  'Astro Droid1':             'Droïde Astro 1',
  'Astro Droid2':             'Droïde Astro 2',
  'Astro Droid3':             'Droïde Astro 3',
  'Astro Droid4':             'Droïde Astro 4',
  'Automatic Fire1':          'Tir Automatique 1',
  'Automatic Fire2':          'Tir Automatique 2',
  'Automatic Fire3':          'Tir Automatique 3',
  'Automatic Fire4':          'Tir Automatique 4',
  'Avalanche':                'Avalanche',
  'Axe Attack1':              'Attaque à la Hache 1',
  'Axe Attack2':              'Attaque à la Hache 2',
  'Axe Attack3':              'Attaque à la Hache 3',
  'Axe Attack4':              'Attaque à la Hache 4',

  // === B ===
  'Babtistery':               'Baptistère',
  'Balista1':                 'Baliste 1',
  'Balista2':                 'Baliste 2',
  'Banners Flapping':         'Bannières au Vent',
  'Bar Door':                 'Porte de Bar',
  'Bartender1':               'Barman 1',
  'Bartender2':               'Barman 2',
  'Bartender3':               'Barman 3',
  'Bartender4':               'Barman 4',
  'Bass Tone':                'Tonalité Basse',
  'Bat Colony':               'Colonie de Chauves-souris',
  'Bats':                     'Chauves-souris',
  'Bats Startle':             'Chauves-souris Effrayées',
  'Battering Ram1':           'Bélier 1',
  'Battering Ram2':           'Bélier 2',
  'Battering Ram3':           'Bélier 3',
  'Battering Ram4':           'Bélier 4',
  'Battle Close':             'Bataille Proche',
  'Battle Cry1':              'Cri de Guerre 1',
  'Battle Cry2':              'Cri de Guerre 2',
  'Battle Distant':           'Bataille Lointaine',
  'Bear Growl':               'Grognement d\'Ours',
  'Beast Of Burden1':         'Bête de Somme 1',
  'Beast Of Burden2':         'Bête de Somme 2',
  'Beast Of Burden3':         'Bête de Somme 3',
  'Beat To Quarters':         'Branle-bas de Combat',
  'Belfry':                   'Beffroi',
  'Bell':                     'Cloche',
  'Bell Tone':                'Son de Cloche',
  'Below Decks':              'Sous le Pont',
  'Bent Tone':                'Tonalité Déformée',
  'Bicycles':                 'Vélos',
  'Bilge Pumps':              'Pompes de Cale',
  'Bird Flock':               'Vol d\'Oiseaux',
  'Birds Wind':               'Oiseaux et Vent',
  'Birds1':                   'Oiseaux 1',
  'Birds2':                   'Oiseaux 2',
  'Bite1':                    'Morsure 1',
  'Bite2':                    'Morsure 2',
  'Blacksmith':               'Forgeron',
  'Blade Attack1':            'Attaque à la Lame 1',
  'Blade Attack2':            'Attaque à la Lame 2',
  'Blade Attack3':            'Attaque à la Lame 3',
  'Blade On Blade':           'Lame contre Lame',
  'Blade Trap':               'Piège à Lames',
  'Blaster 1 Burst':          'Blaster 1 Rafale',
  'Blaster 1 Single':         'Blaster 1 Tir Simple',
  'Blaster 2 Burst':          'Blaster 2 Rafale',
  'Blaster 2 Single':         'Blaster 2 Tir Simple',
  'Blaster Reload':           'Rechargement Blaster',
  'Boat In Harbor':           'Bateau au Port',
  'Boiling Pitch':            'Poix Bouillante',
  'Boiling Sand':             'Sable Bouillonnant',
  'Bombardment':              'Bombardement',
  'Boom Tone':                'Tonalité Boom',
  'Bosuns Whistle':           'Sifflet du Bosco',
  'Bow Multi':                'Arc Tirs Multiples',
  'Bow Single':               'Arc Tir Simple',
  'Bow Wash Heavy':           'Remous de Proue Fort',
  'Bow Wash Light':           'Remous de Proue Léger',
  'Bow Wash Med':             'Remous de Proue Moyen',
  'Braam Tone':               'Tonalité Braam',
  'Brass Tone':               'Tonalité de Cuivres',
  'Brazier':                  'Brasero',
  'Breeze':                   'Brise',
  'Breeze Birds':             'Brise et Oiseaux',
  'Brimstone Pool':           'Mare de Soufre',
  'Broadside1':               'Bordée 1',
  'Broadside2':               'Bordée 2',
  'Broadside3':               'Bordée 3',
  'Broadside4':               'Bordée 4',
  'Bronze Door Close':        'Porte de Bronze Fermeture',
  'Bronze Door Open':         'Porte de Bronze Ouverture',
  'Brooding Wind':            'Vent Menaçant',
  'Bubbles':                  'Bulles',
  'Burning':                  'Flammes',
  'Busy Atmos':               'Ambiance Animée',

  // === C ===
  'Cage Elevator':            'Ascenseur à Cage',
  'Call To Prayer':           'Appel à la Prière',
  'Campfire':                 'Feu de Camp',
  'Car Door Close':           'Porte de Voiture Fermeture',
  'Car Door Open':            'Porte de Voiture Ouverture',
  'Car Driving Int':          'Voiture Intérieur',
  'Car Horn':                 'Klaxon',
  'Car Idle':                 'Voiture au Ralenti',
  'Car Idle Ext':             'Voiture au Ralenti (Ext.)',
  'Cards Deal':               'Distribution de Cartes',
  'Catacombs':                'Catacombes',
  'Cauldron':                 'Chaudron',
  'Cell Phone':               'Téléphone Portable',
  'Chain Winch':              'Treuil à Chaîne',
  'Chains':                   'Chaînes',
  'Chant':                    'Chant Rituel',
  'Chaotic Tone':             'Tonalité Chaotique',
  'Chariot Race':             'Course de Chars',
  'Cheer':                    'Acclamation',
  'Cheer1':                   'Acclamation 1',
  'Cheer2':                   'Acclamation 2',
  'Cheer3':                   'Acclamation 3',
  'Cheer4':                   'Acclamation 4',
  'Cheers':                   'Acclamations',
  'Cheers1':                  'Acclamations 1',
  'Cheers2':                  'Acclamations 2',
  'Cheers3':                  'Acclamations 3',
  'Cheers4':                  'Acclamations 4',
  'Chest Open':               'Ouverture de Coffre',
  'Chickens':                 'Poules',
  'Children Laugh':           'Rires d\'Enfants',
  'Choir Tone':               'Tonalité Chorale',
  'Choral Tone':              'Tonalité Chorale',
  'Chugging Contest':         'Concours de Boisson',
  'Church Bell':              'Cloche d\'Église',
  'Church Bell Peal':         'Carillon d\'Église',
  'Church Bell Single':       'Cloche d\'Église Simple',
  'Cicadas':                  'Cigales',
  'Cigarette Light':          'Allumer une Cigarette',
  'City Gate Close':          'Porte de Ville Fermeture',
  'City Gate Open':           'Porte de Ville Ouverture',
  'Cleaning Fish':            'Nettoyage de Poisson',
  'Clifftop':                 'Sommet de Falaise',
  'Clock':                    'Horloge',
  'Clock Chime':              'Carillon d\'Horloge',
  'Close Combat':             'Combat Rapproché',
  'Close Growls1':            'Grognements Proches 1',
  'Close Growls2':            'Grognements Proches 2',
  'Close Growls3':            'Grognements Proches 3',
  'Close Growls4':            'Grognements Proches 4',
  'Close Thunder':            'Tonnerre Proche',
  'Club Attack':              'Attaque à la Massue',
  'Club Vip Room':            'Salle VIP du Club',
  'Coins On Bar':             'Pièces sur le Comptoir',
  'Coldfire':                 'Feu Glacé',
  'Computers':                'Ordinateurs',
  'Conjuring':                'Invocation',
  'Construction':             'Construction',
  'Countryside Day':          'Campagne de Jour',
  'Courtroom Amb':            'Ambiance Tribunal',
  'Cows':                     'Vaches',
  'Coyotes':                  'Coyotes',
  'Creaking Floor':           'Plancher Grinçant',
  'Creature':                 'Créature',
  'Creature Approach':        'Créature Approche',
  'Creature Attack1':         'Attaque de Créature 1',
  'Creature Attack2':         'Attaque de Créature 2',
  'Creature Growl':           'Grognement de Créature',
  'Creature Growl1':          'Grognement de Créature 1',
  'Creature Growl2':          'Grognement de Créature 2',
  'Creature Lurk1':           'Créature Rôdante 1',
  'Creature Lurk2':           'Créature Rôdante 2',
  'Creature Lurk3':           'Créature Rôdante 3',
  'Creature Lurk4':           'Créature Rôdante 4',
  'Creature Roar':            'Rugissement de Créature',
  'Creature Roar1':           'Rugissement de Créature 1',
  'Creature Roar2':           'Rugissement de Créature 2',
  'Crickets':                 'Grillons',
  'Crow 1':                   'Corbeau 1',
  'Crow 2':                   'Corbeau 2',
  'Crowd Cheer':              'Acclamation de Foule',
  'Crowd Station':            'Foule en Gare',
  'Crows':                    'Corbeaux',
  'Crystalline Orb':          'Orbe Cristallin',
  'Cultist Cavern':           'Caverne de Cultistes',
  'Cultists Prayer':          'Prière de Cultistes',
  'Cups And Plates':          'Tasses et Assiettes',
  'Cutlass Fight':            'Combat au Sabre',

  // === D ===
  'Dagger Attack':            'Attaque à la Dague',
  'Damage1':                  'Dégâts 1',
  'Damage2':                  'Dégâts 2',
  'Damage3':                  'Dégâts 3',
  'Damage4':                  'Dégâts 4',
  'Dark Prayer':              'Prière Sombre',
  'Dark Pulse':               'Pulsation Sombre',
  'Dark Tone':                'Tonalité Sombre',
  'Dark Wind':                'Vent Sombre',
  'Data Comms1':              'Transmissions 1',
  'Data Comms2':              'Transmissions 2',
  'Decapitation1':            'Décapitation 1',
  'Decapitation2':            'Décapitation 2',
  'Deck Activity':            'Activité sur le Pont',
  'Deep Rumble':              'Grondement Profond',
  'Defensive Orders1':        'Ordres Défensifs 1',
  'Defensive Orders2':        'Ordres Défensifs 2',
  'Defensive Orders3':        'Ordres Défensifs 3',
  'Defensive Orders4':        'Ordres Défensifs 4',
  'Demon Voice 1':            'Voix Démoniaque 1',
  'Demon Voice 2':            'Voix Démoniaque 2',
  'Demon Voice 3':            'Voix Démoniaque 3',
  'Demon Voice 4':            'Voix Démoniaque 4',
  'Didgeri Tone':             'Tonalité Didgeridoo',
  'Diesel Engine':            'Moteur Diesel',
  'Distant Army':             'Armée Lointaine',
  'Distant Combat':           'Combat Lointain',
  'Distant Drums':            'Tambours Lointains',
  'Distant Explosions':       'Explosions Lointaines',
  'Distant Groans':           'Gémissements Lointains',
  'Distant Howls':            'Hurlements Lointains',
  'Distant Howls1':           'Hurlements Lointains 1',
  'Distant Howls2':           'Hurlements Lointains 2',
  'Distant Howls3':           'Hurlements Lointains 3',
  'Distant Howls4':           'Hurlements Lointains 4',
  'Distant Predators':        'Prédateurs Lointains',
  'Distant Sea':              'Mer Lointaine',
  'Distant Shouting':         'Cris Lointains',
  'Distant Thunder':          'Tonnerre Lointain',
  'Dock Creaks':              'Grincements du Quai',
  'Docks':                    'Quais',
  'Dockside Bar':             'Bar du Port',
  'Dog Bark':                 'Aboiement',
  'Dog Pack':                 'Meute de Chiens',
  'Dog Snarl 1':              'Grognement de Chien 1',
  'Dog Snarl 2':              'Grognement de Chien 2',
  'Dog Snarl 3':              'Grognement de Chien 3',
  'Dogs Barking':             'Chiens qui Aboient',
  'Door Break':               'Porte Enfoncée',
  'Door Close':               'Porte Fermeture',
  'Door Force Open':          'Porte Forcée',
  'Door Knock':               'Frappe à la Porte',
  'Door Open':                'Porte Ouverture',
  'Door Sm Close':            'Petite Porte Fermeture',
  'Door Sm Open':             'Petite Porte Ouverture',
  'Door Unlock':              'Déverrouillage de Porte',
  'Doors Distant1':           'Portes Lointaines 1',
  'Doors Distant2':           'Portes Lointaines 2',
  'Doors Heavy Close':        'Lourde Porte Fermeture',
  'Doors Heavy Open':         'Lourde Porte Ouverture',
  'Doors Sm Close':           'Petite Porte Fermeture',
  'Doors Sm Open':            'Petite Porte Ouverture',
  'Dragon Away':              'Dragon s\'Éloigne',
  'Dragon Landing':           'Dragon Atterrit',
  'Drawbridge Distant':       'Pont-Levis Lointain',
  'Drawer Close':             'Tiroir Fermeture',
  'Drawer Open':              'Tiroir Ouverture',
  'Dream Tone':               'Tonalité Onirique',
  'Drips':                    'Gouttes d\'Eau',
  'Drips Leaves':             'Gouttes sur les Feuilles',
  'Drone Pulse':              'Pulsation de Drone',
  'Drone Tone':               'Tonalité de Drone',
  'Drum Tone':                'Tonalité de Tambour',
  'Dry Stone Room':           'Salle de Pierre Sèche',
  'Duduk Tone':               'Tonalité de Duduk',
  'Dulcimer Tone':            'Tonalité de Dulcimer',

  // === E ===
  'Earth Spell':              'Sort de Terre',
  'Eerie Ambience':           'Ambiance Inquiétante',
  'Eerie Noise':              'Bruit Inquiétant',
  'Eerie Streetscape':        'Rue Inquiétante',
  'Eerie Tone':               'Tonalité Inquiétante',
  'Electrical Noises':        'Bruits Électriques',
  'Elevated Rail':            'Rail Aérien',
  'Elevator':                 'Ascenseur',
  'Empty Atmos':              'Ambiance Vide',
  'Empty Facility':           'Installation Déserte',
  'Energy Weap Bg':           'Armes à Énergie (Fond)',
  'Ethereal':                 'Éthéré',
  'Ethereal 2':               'Éthéré 2',
  'Ethereal 3':               'Éthéré 3',
  'Evil Pulse':               'Pulsation Maléfique',
  'Explosion':                'Explosion',
  'Explosion1':               'Explosion 1',
  'Explosion2':               'Explosion 2',

  // === F ===
  'Faerie Frost':             'Givre Féerique',
  'Falling Ice':              'Chute de Glace',
  'Fan Blades':               'Pales de Ventilateur',
  'Fanfare':                  'Fanfare',
  'Feast':                    'Festin',
  'Feet Scuffle':             'Piétinement',
  'Female Laugh Dist':        'Rire Féminin Lointain',
  'Fight Grunts':             'Grognements de Combat',
  'Fire':                     'Feu',
  'Fire Arrow1':              'Flèche Enflammée 1',
  'Fire Arrow2':              'Flèche Enflammée 2',
  'Fire Spell':               'Sort de Feu',
  'Fireplace':                'Cheminée',
  'Flag Sail':                'Drapeau et Voile',
  'Flame Thrower':            'Lance-Flammes',
  'Flash Bulb':               'Flash Photo',
  'Flies':                    'Mouches',
  'Flute Tone':               'Tonalité de Flûte',
  'Fly Swarm':                'Essaim de Mouches',
  'Foghorn':                  'Corne de Brume',
  'Footsteps':                'Pas',
  'Footsteps Ambient':        'Pas Ambiants',
  'Footsteps Boots':          'Pas de Bottes',
  'Footsteps Docks':          'Pas sur les Quais',
  'Footsteps Facility':       'Pas dans l\'Installation',
  'Footsteps Gravel':         'Pas sur le Gravier',
  'Footsteps Heels':          'Pas de Talons',
  'Footsteps In':             'Pas à l\'Intérieur',
  'Footsteps Jungle':         'Pas dans la Jungle',
  'Footsteps Limping':        'Pas Boiteux',
  'Footsteps Metal':          'Pas sur le Métal',
  'Footsteps Monks':          'Pas de Moines',
  'Footsteps Out':            'Pas à l\'Extérieur',
  'Footsteps Sand':           'Pas sur le Sable',
  'Footsteps Snow':           'Pas dans la Neige',
  'Footsteps Spurs':          'Pas avec Éperons',
  'Footsteps Wood':           'Pas sur le Bois',
  'Footsteps1':               'Pas 1',
  'Footsteps2':               'Pas 2',
  'Footsteps3':               'Pas 3',
  'Footsteps4':               'Pas 4',
  'Forcefield Down':          'Champ de Force Désactivé',
  'Forcefield Up':            'Champ de Force Activé',
  'Forge':                    'Forge',
  'Forging Iron':             'Forge du Fer',
  'Fountain':                 'Fontaine',
  'Frogs':                    'Grenouilles',
  'Frost Spider Atk1':        'Attaque d\'Araignée de Givre 1',
  'Frost Spider Atk2':        'Attaque d\'Araignée de Givre 2',
  'Frost Spider Idle':        'Araignée de Givre Passive',
  'Frozen Wind':              'Vent Glacé',
  'Funeral Pyre':             'Bûcher Funéraire',
  'Future City Drone Chimes': 'Ville Future Carillons',

  // === G ===
  'Garage Close':             'Garage Fermeture',
  'Garage Open':              'Garage Ouverture',
  'Garden Fountains':         'Fontaines de Jardin',
  'Gavel':                    'Marteau du Juge',
  'Ghost Whisper':            'Murmure Fantomatique',
  'Giant Footsteps':          'Pas de Géant',
  'Giant Roar1':              'Rugissement de Géant 1',
  'Giant Roar2':              'Rugissement de Géant 2',
  'Glacial River':            'Rivière Glaciaire',
  'Goat Farm':                'Ferme de Chèvres',
  'Gong':                     'Gong',
  'Grandfather Clock':        'Horloge Grand-Père',
  'Great Worm Atk1':          'Attaque du Grand Ver 1',
  'Great Worm Atk2':          'Attaque du Grand Ver 2',
  'Great Worm Idle':          'Grand Ver Passif',
  'Grenade':                  'Grenade',
  'Grotto':                   'Grotte',
  'Ground Quake':             'Tremblement de Sol',
  'Growl':                    'Grognement',
  'Guard Droid1':             'Droïde de Garde 1',
  'Guard Droid2':             'Droïde de Garde 2',
  'Guard Droid3':             'Droïde de Garde 3',
  'Guard Droid4':             'Droïde de Garde 4',
  'Gun Carbine1':             'Carabine 1',
  'Gun Carbine2':             'Carabine 2',
  'Gun Pistol1':              'Pistolet 1',
  'Gun Pistol2':              'Pistolet 2',
  'Gun Pistol3':              'Pistolet 3',
  'Gun Pistol4':              'Pistolet 4',
  'Gunfight':                 'Fusillade',

  // === H ===
  'Hand Scanner':             'Scanner Manuel',
  'Harbor':                   'Port',
  'Harbor Docks':             'Quais du Port',
  'Harmonica1':               'Harmonica 1',
  'Harmonica2':               'Harmonica 2',
  'Harmonica3':               'Harmonica 3',
  'Harmonica4':               'Harmonica 4',
  'Harp Pluck':               'Harpe Pincée',
  'Hawk':                     'Faucon',
  'Hawk Attack1':             'Attaque de Faucon 1',
  'Hawk Attack2':             'Attaque de Faucon 2',
  'Healing Spell':            'Sort de Guérison',
  'Heartbeat':                'Battement de Cœur',
  'Heavy Door Close':         'Lourde Porte Fermeture',
  'Heavy Door Open':          'Lourde Porte Ouverture',
  'Heavy Gate':               'Portail Lourd',
  'Heavy Switch':             'Interrupteur Lourd',
  'Helicopter Hover':         'Hélicoptère en Vol Stationnaire',
  'Helicopter Passby':        'Hélicoptère Passage',
  'Helmet Breath':            'Respiration sous Casque',
  'Hi Synth':                 'Synthé Aigu',
  'Hi Tone':                  'Tonalité Aiguë',
  'Hi Tone 1':                'Tonalité Aiguë 1',
  'Hi Tone 2':                'Tonalité Aiguë 2',
  'Hi Tone 3':                'Tonalité Aiguë 3',
  'High Heels1':              'Talons Hauts 1',
  'High Heels2':              'Talons Hauts 2',
  'Highrise Rooftop':         'Toit de Gratte-Ciel',
  'Hilltop Night':            'Colline de Nuit',
  'Hiss1':                    'Sifflement 1',
  'Hiss2':                    'Sifflement 2',
  'Hiss3':                    'Sifflement 3',
  'Hiss4':                    'Sifflement 4',
  'Hoist Sail':               'Hisser les Voiles',
  'Hollow Wind':              'Vent Creux',
  'Holy Wind':                'Vent Sacré',
  'Horn Distant':             'Cor Lointain',
  'Horn Near':                'Cor Proche',
  'Horror Riser 1':           'Montée d\'Horreur 1',
  'Horror Riser 2':           'Montée d\'Horreur 2',
  'Horror Tone':              'Tonalité Horrifique',
  'Horse Attack':             'Attaque à Cheval',
  'Horse Canter Ice':         'Cheval au Galop sur Glace',
  'Horse Cart':               'Chariot à Cheval',
  'Horse Carts':              'Chariots à Chevaux',
  'Horse Gallop':             'Galop de Cheval',
  'Horse Outside':            'Cheval Dehors',
  'Horse Traffic':            'Circulation Équestre',
  'Horse Trot':               'Trot de Cheval',
  'Horse Walk':               'Cheval au Pas',
  'Horse Walk Ice':           'Cheval au Pas sur Glace',
  'Horseback':                'À Cheval',
  'Horses':                   'Chevaux',
  'Horses Gallop':            'Galop de Chevaux',
  'Horses Riding':            'Chevauchée',
  'Hospital':                 'Hôpital',
  'Hotel Lobby':              'Hall d\'Hôtel',
  'House Rattle':             'Maison qui Tremble',
  'Howlers':                  'Hurleurs',
  'Huge Footsteps':           'Pas Énormes',
  'Humanoid Camp':            'Camp Humanoïde',
  'Hurdy Gurdy':              'Vielle à Roue',
  'Hushed Atmos':             'Ambiance Feutrée',

  // === I ===
  'Ice Artifact':             'Artefact de Glace',
  'Ice Axe':                  'Hache de Glace',
  'Ice Creaks':               'Craquements de Glace',
  'Ice Creaks1':              'Craquements de Glace 1',
  'Ice Creaks2':              'Craquements de Glace 2',
  'Ice Creaks3':              'Craquements de Glace 3',
  'Ice Creaks4':              'Craquements de Glace 4',
  'Ice Door Close':           'Porte de Glace Fermeture',
  'Ice Door Open':            'Porte de Glace Ouverture',
  'Ice In Glass':             'Glaçons dans le Verre',
  'Ice Spell':                'Sort de Glace',
  'Immolation1':              'Immolation 1',
  'Immolation2':              'Immolation 2',
  'Impact':                   'Impact',
  'Incoming Arrows':          'Flèches Entrantes',
  'Innkeeper1':               'Aubergiste 1',
  'Innkeeper2':               'Aubergiste 2',
  'Innkeeper3':               'Aubergiste 3',
  'Innkeeper4':               'Aubergiste 4',
  'Innkeeper5':               'Aubergiste 5',
  'Innkeeper6':               'Aubergiste 6',
  'Innkeeper7':               'Aubergiste 7',
  'Innkeeper8':               'Aubergiste 8',
  'Insect Swarm':             'Essaim d\'Insectes',
  'Insects':                  'Insectes',
  'Investigators Office':     'Bureau d\'Enquêteur',
  'Iron Lung':                'Poumon d\'Acier',
  'Isolation Tank':           'Caisson d\'Isolation',

  // === J-K ===
  'Jeers':                    'Huées',
  'Kelp Forest':              'Forêt de Kelp',

  // === L ===
  'Ladies Laugh':             'Rires de Femmes',
  'Lantern':                  'Lanterne',
  'Large Crowd':              'Grande Foule',
  'Large Market':             'Grand Marché',
  'Laser Turret':             'Tourelle Laser',
  'Laughter1':                'Rire 1',
  'Laughter2':                'Rire 2',
  'Laughter3':                'Rire 3',
  'Laughter4':                'Rire 4',
  'Lava Flow':                'Coulée de Lave',
  'Leviathan1':               'Léviathan 1',
  'Leviathan2':               'Léviathan 2',
  'Leviathan3':               'Léviathan 3',
  'Leviathan4':               'Léviathan 4',
  'Lg Craft Engine':          'Moteur Grand Vaisseau',
  'Lg Creature Roar':         'Rugissement Grande Créature',
  'Lg Drum Tone':             'Tonalité Grand Tambour',
  'Lg Group Fight':           'Combat de Grand Groupe',
  'Lg Group Voices':          'Voix Grand Groupe',
  'Lg Hatch Close':           'Grande Trappe Fermeture',
  'Lg Hatch Open':            'Grande Trappe Ouverture',
  'Lg Ship Pass':             'Passage Grand Vaisseau',
  'Lg Waterfall':             'Grande Cascade',
  'Light Applause':           'Applaudissements Légers',
  'Light Rain':               'Pluie Fine',
  'Light Sword Atk1':         'Attaque Sabre Laser 1',
  'Light Sword Atk2':         'Attaque Sabre Laser 2',
  'Light Sword Atk3':         'Attaque Sabre Laser 3',
  'Light Sword Atk4':         'Attaque Sabre Laser 4',
  'Light Sword Fight':        'Combat au Sabre Laser',
  'Light Sword Off':          'Sabre Laser Extinction',
  'Light Sword On':           'Sabre Laser Activation',
  'Light Wind':               'Vent Léger',
  'Lightbulb Glitch':         'Ampoule qui Grésille',
  'Lightning Pillars':        'Piliers de Foudre',
  'Lightning Strike1':        'Éclair 1',
  'Lightning Strike2':        'Éclair 2',
  'Little Girl1':             'Petite Fille 1',
  'Little Girl2':             'Petite Fille 2',
  'Little Girl3':             'Petite Fille 3',
  'Little Girl4':             'Petite Fille 4',
  'Lo Tone':                  'Tonalité Basse',
  'Loading Bay':              'Baie de Chargement',
  'Longhouse Banquet':        'Banquet de la Longère',
  'Longhouse Empty':          'Longère Vide',
  'Longship Fast':            'Drakkar Rapide',
  'Longship Slow':            'Drakkar Lent',
  'Lounge Ambience':          'Ambiance Lounge',
  'Low Breath':               'Respiration Basse',
  'Low Pulse':                'Pulsation Basse',
  'Low Synth':                'Synthé Grave',
  'Low Tone':                 'Tonalité Grave',
  'Low Wind':                 'Vent Faible',
  'Lower Deck':               'Pont Inférieur',

  // === M ===
  'Machinery':                'Machinerie',
  'Mag Lev Arrive':           'Maglev Arrivée',
  'Mag Lev Depart':           'Maglev Départ',
  'Magic Aura':               'Aura Magique',
  'Magic Tone':               'Tonalité Magique',
  'Magic Trap':               'Piège Magique',
  'Male Laugh Dist1':         'Rire Masculin Lointain 1',
  'Male Laugh Dist2':         'Rire Masculin Lointain 2',
  'Male Laugh Dist3':         'Rire Masculin Lointain 3',
  'Male Laugh Dist4':         'Rire Masculin Lointain 4',
  'Man Fishing':              'Homme qui Pêche',
  'Mangonel1':                'Mangonneau 1',
  'Mangonel2':                'Mangonneau 2',
  'Manor House':              'Manoir',
  'Market':                   'Marché',
  'Market District':          'Quartier du Marché',
  'Market Voices':            'Voix du Marché',
  'Massive Stone Door':       'Immense Porte de Pierre',
  'Mast Creaks':              'Grincements du Mât',
  'Mech Sentry':              'Sentinelle Mécanique',
  'Med Ship Pass':            'Passage Vaisseau Moyen',
  'Medium Crowd':             'Foule Moyenne',
  'Medium Rain':              'Pluie Modérée',
  'Melody Synth':             'Synthé Mélodique',
  'Merchant Cart':            'Chariot de Marchand',
  'Metal Bangs1':             'Coups Métalliques 1',
  'Metal Bangs2':             'Coups Métalliques 2',
  'Metal Cart':               'Chariot Métallique',
  'Metal Gate':               'Portail Métallique',
  'Metal Groans':             'Grincements Métalliques',
  'Metal Tone Loop2':         'Tonalité Métal 2',
  'Metro Tunnel':             'Tunnel de Métro',
  'Mid Tone':                 'Tonalité Moyenne',
  'Missle Launch':            'Lancement de Missile',
  'Misty Wind':               'Vent Brumeux',
  'Mosquito':                 'Moustique',

  // === Music tracks ===
  'Music Action':                   'Musique Action',
  'Music Action 1':                 'Musique Action 1',
  'Music Action 2':                 'Musique Action 2',
  'Music Ares Commands':            'Musique Ordres d\'Arès',
  'Music Awaken':                   'Musique Éveil',
  'Music Bard Ballad':              'Musique Ballade du Barde',
  'Music Bard Lively 1':            'Musique Barde Enjoué 1',
  'Music Bard Lively 2':            'Musique Barde Enjoué 2',
  'Music Bella Voce':               'Musique Bella Voce',
  'Music Benedictus':               'Musique Benedictus',
  'Music Chase':                    'Musique Poursuite',
  'Music City Of Wonder V2':        'Musique Cité des Merveilles',
  'Music Club':                     'Musique Club',
  'Music Club Inside':              'Musique Club Intérieur',
  'Music Club Outside':             'Musique Club Extérieur',
  'Music Code Of The Raven':        'Musique Code du Corbeau',
  'Music Combat':                   'Musique Combat',
  'Music Cool City':                'Musique Ville Cool',
  'Music Dark City':                'Musique Ville Sombre',
  'Music Deep Drums':               'Musique Tambours Profonds',
  'Music Desert':                   'Musique Désert',
  'Music Destiny':                  'Musique Destinée',
  'Music Dies Irae':                'Musique Dies Irae',
  'Music Disorient':                'Musique Désorientant',
  'Music Dream':                    'Musique Rêve',
  'Music Drunken Sailor':           'Musique Marin Ivre',
  'Music Dusk Over Delphi':         'Musique Crépuscule sur Delphes',
  'Music Elven Flute':              'Musique Flûte Elfique',
  'Music Endless Night':            'Musique Nuit Sans Fin',
  'Music Far From Home':            'Musique Loin de Chez Soi',
  'Music Feast Of Odin':            'Musique Festin d\'Odin',
  'Music Feast Of Odin Lvl1':       'Musique Festin d\'Odin Niv.1',
  'Music Feast Of Odin Lvl2':       'Musique Festin d\'Odin Niv.2',
  'Music Forest Action':            'Musique Action en Forêt',
  'Music Forest Combat':            'Musique Combat en Forêt',
  'Music Heart Of War':             'Musique Cœur de Guerre',
  'Music Intrigue':                 'Musique Intrigue',
  'Music Lost City':                'Musique Cité Perdue',
  'Music Mournful':                 'Musique Funèbre',
  'Music Music Box':                'Musique Boîte à Musique',
  'Music Organ Close':              'Musique Orgue Proche',
  'Music Organ Distant':            'Musique Orgue Lointain',
  'Music Saloon Piano 1':           'Musique Piano Saloon 1',
  'Music Saloon Piano 2':           'Musique Piano Saloon 2',
  'Music Sanctus Agnus':            'Musique Sanctus Agnus',
  'Music Scifi Action':             'Musique Action Sci-Fi',
  'Music Scifi Combat':             'Musique Combat Sci-Fi',
  'Music Scifi Suspense':           'Musique Suspense Sci-Fi',
  'Music Sirens Song':              'Musique Chant des Sirènes',
  'Music Spell':                    'Musique Envoûtement',
  'Music Synth Dawn':               'Musique Synthé Aube',
  'Music Synth Drama':              'Musique Synthé Drame',
  'Music Synth Mall':               'Musique Synthé Centre Commercial',
  'Music Synth Tension':            'Musique Synthé Tension',
  'Music Tension':                  'Musique Tension',
  'Music The Depths':               'Musique Les Profondeurs',
  'Music Theme':                    'Musique Thème',
  'Music Theme Music':              'Musique Thème Principal',
  'Music Trapped':                  'Musique Piégé',
  'Music Tribal':                   'Musique Tribale',
  'Music Victrola':                 'Musique Victrola',
  'Music Violin Melody':            'Musique Mélodie au Violon',
  'Music Waltz':                    'Musique Valse',
  'Music Welcome':                  'Musique Bienvenue',
  'Music Western Action':           'Musique Action Western',

  // === N ===
  'Nature Spell':             'Sort de Nature',
  'Net Trap':                 'Piège à Filet',
  'Newspaper Shuffle':        'Froissement de Journal',

  // === O ===
  'Offensive Orders1':        'Ordres Offensifs 1',
  'Offensive Orders2':        'Ordres Offensifs 2',
  'Offensive Orders3':        'Ordres Offensifs 3',
  'Offensive Orders4':        'Ordres Offensifs 4',
  'Office Amb':               'Ambiance de Bureau',
  'Old Drunk1':               'Vieil Ivrogne 1',
  'Old Drunk2':               'Vieil Ivrogne 2',
  'Old Drunk3':               'Vieil Ivrogne 3',
  'Old Drunk4':               'Vieil Ivrogne 4',
  'Old Phone':                'Vieux Téléphone',
  'Ominous Wind':             'Vent Sinistre',
  'On Subway':                'Dans le Métro',
  'Ooze':                     'Vase Vivante',
  'Open File':                'Ouvrir un Dossier',
  'Organ Tone':               'Tonalité d\'Orgue',
  'Ossuary':                  'Ossuaire',
  'Other Side Bg':            'Autre Monde (Fond)',
  'Owl':                      'Hibou',

  // === P ===
  'Panic Tone':               'Tonalité de Panique',
  'Party Laughter':           'Rires de Fête',
  'Peace Keepers':            'Gardiens de la Paix',
  'Percussive Tone':          'Tonalité Percussive',
  'Phalanx Close':            'Phalange Proche',
  'Phalanx Far':              'Phalange Lointaine',
  'Phone Ring':               'Sonnerie de Téléphone',
  'Pigeons':                  'Pigeons',
  'Pistol Shot':              'Coup de Pistolet',
  'Pistol Shot1':             'Coup de Pistolet 1',
  'Pistol Shot2':             'Coup de Pistolet 2',
  'Pit Trap':                 'Piège à Fosse',
  'Plasma Explosion':         'Explosion de Plasma',
  'Poison Trap':              'Piège Empoisonné',
  'Police Car Pass':          'Passage Voiture de Police',
  'Police Scanner':           'Scanner de Police',
  'Police Siren':             'Sirène de Police',
  'Pool Of Water':            'Bassin d\'Eau',
  'Portcullis':               'Herse',
  'Portcullis Close':         'Herse Fermeture',
  'Portcullis Trap':          'Piège à Herse',
  'Pour Ale':                 'Servir la Bière',
  'Pour Whiskey':             'Servir le Whiskey',
  'Power Blast':              'Explosion d\'Énergie',
  'Power Surge1':             'Surtension 1',
  'Power Surge2':             'Surtension 2',
  'Power Surge3':             'Surtension 3',
  'Power Surge4':             'Surtension 4',
  'Predator Swarm':           'Nuée de Prédateurs',
  'Pressure Plate':           'Plaque de Pression',
  'Primates Far':             'Primates Lointains',
  'Primates Near':            'Primates Proches',
  'Probe Droid':              'Droïde Sonde',
  'Projectile1':              'Projectile 1',
  'Projectile2':              'Projectile 2',
  'Protest':                  'Manifestation',
  'Psst1':                    'Psst 1',
  'Psst2':                    'Psst 2',
  'Psst3':                    'Psst 3',
  'Psst4':                    'Psst 4',
  'Psychic Blast1':           'Explosion Psychique 1',
  'Psychic Blast2':           'Explosion Psychique 2',
  'Pulse Tone':               'Tonalité Pulsée',

  // === R ===
  'Raid':                     'Raid',
  'Rail Gun':                 'Canon Électromagnétique',
  'Rain':                     'Pluie',
  'Rain Close':               'Pluie Proche',
  'Rain Distant':             'Pluie Lointaine',
  'Rain Inside':              'Pluie (Intérieur)',
  'Rain On Roof':             'Pluie sur le Toit',
  'Rain On Window':           'Pluie sur la Fenêtre',
  'Rain Outside':             'Pluie (Extérieur)',
  'Rain Street':              'Pluie dans la Rue',
  'Rain Thunder':             'Pluie et Tonnerre',
  'Ranch':                    'Ranch',
  'Raptor Cry':               'Cri de Raptor',
  'Rats':                     'Rats',
  'Rats 1':                   'Rats 1',
  'Rats 2':                   'Rats 2',
  'Ravens1':                  'Corbeaux 1',
  'Ravens2':                  'Corbeaux 2',
  'Reactor2':                 'Réacteur 2',
  'Repairs':                  'Réparations',
  'Restaurant Amb':           'Ambiance Restaurant',
  'Rhythm':                   'Rythme',
  'Rhythm Tone':              'Tonalité Rythmique',
  'Riding Shouts1':           'Cris de Cavaliers 1',
  'Riding Shouts2':           'Cris de Cavaliers 2',
  'Riding Shouts3':           'Cris de Cavaliers 3',
  'Riding Shouts4':           'Cris de Cavaliers 4',
  'Rigging Groans':           'Gréement qui Grince',
  'Rise Chant':               'Chant Ascendant',
  'Risers1':                  'Montées 1',
  'Risers2':                  'Montées 2',
  'Risers3':                  'Montées 3',
  'Risers4':                  'Montées 4',
  'Ritual':                   'Rituel',
  'Roar':                     'Rugissement',
  'Roars1':                   'Rugissements 1',
  'Roars2':                   'Rugissements 2',
  'Roars3':                   'Rugissements 3',
  'Roars4':                   'Rugissements 4',
  'Rock Slide1':              'Éboulement 1',
  'Rock Slide2':              'Éboulement 2',
  'Rocky Shore':              'Côte Rocheuse',
  'Rolling Thunder':          'Tonnerre Roulant',
  'Rope 1':                   'Corde 1',
  'Rope 2':                   'Corde 2',
  'Rope Creaking':            'Grincement de Corde',
  'Rumble':                   'Grondement',
  'Run In Boots':             'Course en Bottes (Int.)',
  'Run In Heels':             'Course en Talons (Int.)',
  'Run Out Boots':            'Course en Bottes (Ext.)',
  'Run Out Heels':            'Course en Talons (Ext.)',

  // === S ===
  'Sailors Shouting':         'Marins qui Crient',
  'Sails Luffing':            'Voiles qui Faseyent',
  'Saloon Doors':             'Portes de Saloon',
  'Saloon Voices':            'Voix du Saloon',
  'Sarcophagus Lid':          'Couvercle de Sarcophage',
  'Scanner Droid':             'Droïde Scanner',
  'Scared Horses':            'Chevaux Effrayés',
  'School Hallway':           'Couloir d\'École',
  'Scrape':                   'Raclement',
  'Scrape Tone':              'Tonalité de Raclement',
  'Scream Hits1':             'Cris d\'Impact 1',
  'Scream Hits2':             'Cris d\'Impact 2',
  'Scream Hits3':             'Cris d\'Impact 3',
  'Scream Hits4':             'Cris d\'Impact 4',
  'Scream Man':               'Cri d\'Homme',
  'Scream Woman':             'Cri de Femme',
  'Screams':                  'Cris',
  'Screams1':                 'Cris 1',
  'Screams2':                 'Cris 2',
  'Screams3':                 'Cris 3',
  'Screams4':                 'Cris 4',
  'Scriptorium':              'Scriptorium',
  'Seagulls':                 'Mouettes',
  'Search Desk':              'Fouille de Bureau',
  'Search1':                  'Fouille 1',
  'Search2':                  'Fouille 2',
  'Secret Bookcase':          'Bibliothèque Secrète',
  'Serve Stew':               'Servir le Ragoût',
  'Sharpen Knife':            'Aiguiser un Couteau',
  'Sherrif1':                 'Shérif 1',
  'Sherrif2':                 'Shérif 2',
  'Sherrif3':                 'Shérif 3',
  'Sherrif4':                 'Shérif 4',
  'Shield Bash':              'Coup de Bouclier',
  'Shield Block1':            'Parade au Bouclier 1',
  'Shield Block2':            'Parade au Bouclier 2',
  'Shield Block3':            'Parade au Bouclier 3',
  'Shield Block4':            'Parade au Bouclier 4',
  'Shield Wall1':             'Mur de Boucliers 1',
  'Shield Wall2':             'Mur de Boucliers 2',
  'Shield Wall3':             'Mur de Boucliers 3',
  'Shield Wall4':             'Mur de Boucliers 4',
  'Shimmer':                  'Scintillement',
  'Ship Bell':                'Cloche de Vaisseau',
  'Ship Landing':             'Atterrissage de Vaisseau',
  'Ship Takeoff':             'Décollage de Vaisseau',
  'Ships Bell':               'Cloche du Navire',
  'Shopping Mall':            'Centre Commercial',
  'Shotgun Fire1':            'Tir de Fusil 1',
  'Shotgun Fire2':            'Tir de Fusil 2',
  'Shout1':                   'Cri 1',
  'Shout2':                   'Cri 2',
  'Shout3':                   'Cri 3',
  'Shout4':                   'Cri 4',
  'Siege Ladder':             'Échelle de Siège',
  'Siege Tower Fall':         'Tour de Siège Chute',
  'Siege Tower Move':         'Tour de Siège Déplacement',
  'Singing Crystals':         'Cristaux Chantants',
  'Singing Ice':              'Glace Chantante',
  'Single Cannon1':           'Canon Simple 1',
  'Single Cannon2':           'Canon Simple 2',
  'Single Cannon3':           'Canon Simple 3',
  'Single Cannon4':           'Canon Simple 4',
  'Single Car Pass':          'Passage d\'une Voiture',
  'Single Fire1':             'Tir Simple 1',
  'Single Fire2':             'Tir Simple 2',
  'Single Fire3':             'Tir Simple 3',
  'Single Fire4':             'Tir Simple 4',
  'Sirens Song1':             'Chant des Sirènes 1',
  'Sirens Song2':             'Chant des Sirènes 2',
  'Sleeping Old One':         'Ancien Endormi',
  'Sm Craft Engine':          'Moteur Petit Vaisseau',
  'Sm Creature':              'Petite Créature',
  'Sm Drum Tone':             'Tonalité Petit Tambour',
  'Sm Group Fight':           'Combat de Petit Groupe',
  'Sm Group Voices':          'Voix Petit Groupe',
  'Sm Waterfall':             'Petite Cascade',
  'Small Bells':              'Petites Cloches',
  'Small Crowd':              'Petite Foule',
  'Snake':                    'Serpent',
  'Snake Pit':                'Fosse aux Serpents',
  'Snarl':                    'Grognement Féroce',
  'Snoring Patron':           'Client qui Ronfle',
  'Snow Boulder':             'Bloc de Neige',
  'Soldiers March':           'Marche des Soldats',
  'Spear Thrust1':            'Coup de Lance 1',
  'Spear Thrust2':            'Coup de Lance 2',
  'Spear Thrust3':            'Coup de Lance 3',
  'Spear Thrust4':            'Coup de Lance 4',
  'Spike Trap':               'Piège à Pointes',
  'Spirit Breath':            'Souffle d\'Esprit',
  'Sprinkler':                'Arroseur',
  'Squeaky Sign':             'Enseigne Grinçante',
  'Stacking Bottles':         'Empilage de Bouteilles',
  'Stacking Crates':          'Empilage de Caisses',
  'Staff Attack':             'Attaque au Bâton',
  'Stagecoach Fast':          'Diligence Rapide',
  'Stagecoach Slow':          'Diligence Lente',
  'Stake In Heart1':          'Pieu dans le Cœur 1',
  'Stake In Heart2':          'Pieu dans le Cœur 2',
  'Stake In Heart3':          'Pieu dans le Cœur 3',
  'Stake In Heart4':          'Pieu dans le Cœur 4',
  'Steady Rain':              'Pluie Continue',
  'Steam':                    'Vapeur',
  'Steam Train':              'Train à Vapeur',
  'Still Water':              'Eau Stagnante',
  'Stim Pak':                 'Stimulant',
  'Sting Harp':               'Sting Harpe',
  'Sting Orchestral':         'Sting Orchestral',
  'Sting Piano':              'Sting Piano',
  'Stone Door Close':         'Porte de Pierre Fermeture',
  'Stone Door Open':          'Porte de Pierre Ouverture',
  'Stone Scrape':             'Raclement de Pierre',
  'Storm Outside':            'Tempête Dehors',
  'Stray Dogs':               'Chiens Errants',
  'Stream':                   'Ruisseau',
  'String Tone':              'Tonalité de Cordes',
  'Strings Tone':             'Tonalité de Cordes',
  'Strong Rain':              'Forte Pluie',
  'Strong Wind':              'Vent Fort',
  'Stun Gun':                 'Pistolet Paralysant',
  'Suburbs Day':              'Banlieue de Jour',
  'Suburbs Night':            'Banlieue de Nuit',
  'Subway Platform':          'Quai de Métro',
  'Suit Breath':              'Respiration de Combinaison',
  'Swim Constant':            'Nage Continue',
  'Swimming Pool':            'Piscine',
  'Swoop In':                 'Piqué Entrée',
  'Swoop Out':                'Piqué Sortie',
  'Symposium':                'Symposium',

  // === T ===
  'Table Flip':               'Table Renversée',
  'Tavern Door Rain':         'Porte de Taverne (Pluie)',
  'Tavern Door Wind':         'Porte de Taverne (Vent)',
  'Tavern Sign':              'Enseigne de Taverne',
  'Telephone Ring':           'Sonnerie de Téléphone',
  'Temple Bells':             'Cloches du Temple',
  'Temple Interior':          'Intérieur du Temple',
  'Temple Of Apollo':         'Temple d\'Apollon',
  'Tent Flapping':            'Tente au Vent',
  'Terminal Access Fail':     'Accès Terminal Échoué',
  'Terminal Access Succeed':  'Accès Terminal Réussi',
  'Thors Thunder1':           'Tonnerre de Thor 1',
  'Thors Thunder2':           'Tonnerre de Thor 2',
  'Throwing Axe1':            'Hache de Lancer 1',
  'Throwing Axe2':            'Hache de Lancer 2',
  'Thunder':                  'Tonnerre',
  'Thunder Clap':             'Coup de Tonnerre',
  'Thunder Outside':          'Tonnerre Dehors',
  'Timpani Tone':             'Tonalité de Timbales',
  'Tomb Door Close':          'Porte de Tombe Fermeture',
  'Tomb Door Open':           'Porte de Tombe Ouverture',
  'Torch':                    'Torche',
  'Torch Movement':           'Mouvement de Torche',
  'Town Square':              'Place du Village',
  'Toy Trains':               'Trains Miniatures',
  'Trad Festival Music':      'Musique de Festival Traditionnelle',
  'Traffic Air':              'Trafic Aérien',
  'Traffic Distant':          'Trafic Lointain',
  'Traffic Road':             'Trafic Routier',
  'Traffic Wet':              'Trafic sous la Pluie',
  'Train Whistle':            'Sifflet de Train',
  'Training':                 'Entraînement',
  'Trap Arrow':               'Piège à Flèches',
  'Trap Blade':               'Piège à Lames',
  'Trap Door Close':          'Trappe Fermeture',
  'Trap Door Open':           'Trappe Ouverture',
  'Trap Magic':               'Piège Magique',
  'Trap Net':                 'Piège à Filet',
  'Trap Pit':                 'Piège à Fosse',
  'Trap Poison':              'Piège Empoisonné',
  'Trap Portcullis':          'Piège à Herse',
  'Trap Spike':               'Piège à Pointes',
  'Treb Damage1':             'Dégâts Trébuchet 1',
  'Treb Damage2':             'Dégâts Trébuchet 2',
  'Treble Tone':              'Tonalité Aiguë',
  'Trebuchet1':               'Trébuchet 1',
  'Trebuchet2':               'Trébuchet 2',
  'Tree Fall':                'Chute d\'Arbre',
  'Tremolo Tone':             'Tonalité Tremolo',
  'Tremor 1':                 'Tremblement 1',
  'Tremor 2':                 'Tremblement 2',
  'Trireme Oars':             'Rames de Trirème',
  'Trireme Sailing':          'Trirème en Navigation',
  'Twisting Metal':           'Métal Tordu',

  // === U ===
  'Unarmed1':                 'Mains Nues 1',
  'Unarmed2':                 'Mains Nues 2',
  'Unarmed3':                 'Mains Nues 3',
  'Unarmed4':                 'Mains Nues 4',
  'Under Overpass':           'Sous le Pont Routier',
  'Underwater Deep':          'Sous l\'Eau Profond',
  'Underwater Mid':           'Sous l\'Eau Moyen',
  'Underwater Top':           'Sous l\'Eau Surface',
  'Unholy Wind':              'Vent Impie',
  'Upper Deck':               'Pont Supérieur',
  'Urban Park Night':         'Parc Urbain de Nuit',

  // === V ===
  'Village':                  'Village',
  'Village Bell':             'Cloche du Village',
  'Village Burning':          'Village en Flammes',
  'Vocal Tone':               'Tonalité Vocale',
  'Vortex':                   'Vortex',

  // === W ===
  'Wail':                     'Plainte',
  'Walkie Talkie1':           'Talkie-Walkie 1',
  'Walkie Talkie2':           'Talkie-Walkie 2',
  'Walkie Talkie3':           'Talkie-Walkie 3',
  'Walkie Talkie4':           'Talkie-Walkie 4',
  'Wall Collapse':            'Effondrement de Mur',
  'Wall Torches':             'Torches Murales',
  'Walls Shudder':            'Murs qui Tremblent',
  'War Banner':               'Bannière de Guerre',
  'War Drums':                'Tambours de Guerre',
  'War Horn':                 'Cor de Guerre',
  'War Hounds':               'Chiens de Guerre',
  'Warehouse Door':           'Porte d\'Entrepôt',
  'Warehouse Door Close':     'Porte d\'Entrepôt Fermeture',
  'Warehouse Door Open':      'Porte d\'Entrepôt Ouverture',
  'Warehouse Interior':       'Intérieur d\'Entrepôt',
  'Warhammer1':               'Marteau de Guerre 1',
  'Warhammer2':               'Marteau de Guerre 2',
  'Warhammer3':               'Marteau de Guerre 3',
  'Warhammer4':               'Marteau de Guerre 4',
  'Wasteland Birds Startle':        'Oiseaux Effrayés',
  'Wasteland Bone Chimes':          'Carillons d\'Os',
  'Wasteland Burning Building':     'Bâtiment en Flammes',
  'Wasteland Debris Rubble':        'Débris et Gravats',
  'Wasteland Dog Walking':          'Chien Errant',
  'Wasteland Dogs Distant':         'Chiens Lointains',
  'Wasteland Eerie Tone':           'Tonalité Inquiétante',
  'Wasteland Explosions Dist1':     'Explosions Lointaines 1',
  'Wasteland Explosions Dist2':     'Explosions Lointaines 2',
  'Wasteland Explosions Dist3':     'Explosions Lointaines 3',
  'Wasteland Explosions Dist4':     'Explosions Lointaines 4',
  'Wasteland Footsteps Crunch':     'Pas sur les Gravats',
  'Wasteland Footsteps Int':        'Pas (Intérieur)',
  'Wasteland Gas Mask':             'Masque à Gaz',
  'Wasteland Gunfire Dist1':        'Tirs Lointains 1',
  'Wasteland Gunfire Dist2':        'Tirs Lointains 2',
  'Wasteland Gunfire Dist3':        'Tirs Lointains 3',
  'Wasteland Gunfire Dist4':        'Tirs Lointains 4',
  'Wasteland Low Drone':            'Drone Bas',
  'Wasteland Metal Gate Open':      'Portail Métallique Ouverture',
  'Wasteland Metal Noises':         'Bruits Métalliques',
  'Wasteland Neon Light Flicker':   'Néon qui Grésille',
  'Wasteland Ominous Pulse':        'Pulsation Menaçante',
  'Wasteland Radiation Lvl 1':      'Radiation Niv. 1',
  'Wasteland Radiation Lvl 2':      'Radiation Niv. 2',
  'Wasteland Radiation Lvl 3':      'Radiation Niv. 3',
  'Wasteland Rain On Shelter':      'Pluie sur l\'Abri',
  'Wasteland Shaker Rhythm':        'Rythme de Shaker',
  'Wasteland Short Tones':          'Tonalités Courtes',
  'Wasteland Shotgun Cock':         'Armement Fusil',
  'Wasteland Shotgun Fire1':        'Tir de Fusil 1',
  'Wasteland Shotgun Fire2':        'Tir de Fusil 2',
  'Wasteland Shotgun Fire3':        'Tir de Fusil 3',
  'Wasteland Shotgun Fire4':        'Tir de Fusil 4',
  'Wasteland Shotgun Load':         'Chargement Fusil',
  'Wasteland Vultures':             'Vautours',
  'Wasteland Waste Creature1':      'Créature des Déchets 1',
  'Wasteland Waste Creature2':      'Créature des Déchets 2',
  'Wasteland Waste Creature3':      'Créature des Déchets 3',
  'Wasteland Waste Creature4':      'Créature des Déchets 4',
  'Wasteland Wind Desolate':        'Vent Désolé',
  'Wasteland Wind Howl':            'Vent Hurlant',
  'Wasteland Wind Interior':        'Vent (Intérieur)',
  'Wasteland Wolf Distant':         'Loup Lointain',
  'Water':                    'Eau',
  'Water Lapping':            'Clapotis',
  'Water Portal':             'Portail d\'Eau',
  'Water Rising':             'Montée des Eaux',
  'Water Whoosh1':            'Jet d\'Eau 1',
  'Water Whoosh2':            'Jet d\'Eau 2',
  'Waves Surface':            'Vagues en Surface',
  'Whip Crack1':              'Claquement de Fouet 1',
  'Whip Crack2':              'Claquement de Fouet 2',
  'Whip Crack3':              'Claquement de Fouet 3',
  'Whiskey Pour':             'Servir le Whiskey',
  'Whispers':                 'Chuchotements',
  'Whispers1':                'Chuchotements 1',
  'Whispers2':                'Chuchotements 2',
  'Wilhelm Scream':           'Cri de Wilhelm',
  'Winch':                    'Treuil',
  'Wind':                     'Vent',
  'Wind Blustery':            'Vent Bourrasque',
  'Wind Crickets':            'Vent et Grillons',
  'Wind Gusting':             'Rafales de Vent',
  'Wind Howl':                'Vent Hurlant',
  'Wind Ice Cave':            'Vent Grotte de Glace',
  'Wind Outside':             'Vent (Extérieur)',
  'Wind Plains':              'Vent des Plaines',
  'Wind Sandstorm':           'Tempête de Sable',
  'Wind Steady':              'Vent Régulier',
  'Wind Strong':              'Vent Fort',
  'Wind Tundra':              'Vent de Toundra',
  'Window Break':             'Bris de Fenêtre',
  'Windshield Wipers':        'Essuie-Glaces',
  'Wolf Attack1':             'Attaque de Loup 1',
  'Wolf Attack2':             'Attaque de Loup 2',
  'Wolf Attack3':             'Attaque de Loup 3',
  'Wolf Attack4':             'Attaque de Loup 4',
  'Wolf Howl':                'Hurlement de Loup',
  'Wolves Close':             'Loups Proches',
  'Wolves Growling':          'Loups Grognant',
  'Wood Groans':              'Bois qui Grince',
  'Writing Quill':            'Plume d\'Écriture',
};

/**
 * Get the localized name for a sound.
 * @param {string} name - English sound name
 * @param {string} lang - Language code ('fr' or 'en')
 * @returns {string} Localized name
 */
export function getLocalizedSoundName(name, lang) {
  if (lang !== 'fr') return name;
  return soundTranslations[name] || name;
}

/**
 * Get the localized name for a category.
 * @param {string} name - English category name
 * @param {string} lang - Language code ('fr' or 'en')
 * @returns {string} Localized name
 */
export function getLocalizedCategoryName(name, lang) {
  if (lang !== 'fr') return name;
  return categoryTranslations[name] || name;
}
